import { ValidationRules } from "@/models/Validation";
import PartPersonRelation, { PartPersonRelationDefaultProps } from "./PartPersonRelation";

export default interface PartPerson {
    // id: number;
    // name: string;
    // sex: boolean;
    // profession: string;
    // city: string;
    // postcode: string;
    // address: string;
    // otherNo: string;
    // email: string;
    // mobile: string;
    // deleted: boolean;
    // inEdit: boolean;
    // partnerId: number | null;
    id: number;
    partnerId: number;
    fullName: string;
    firstName: string | null;
    marriedStatus: number | null;
    marriedStatusName: string | null;
    sex: boolean;
    birthday: Date | null;
    profession: string | null;
    employType: number;
    employeTypeName: string | null;
    city: number;
    cityName: string | null;
    cityPostCode: string | null;
    address: string | null;
    fullNameCode: string;
    addressCode: string | null;
    birthPlace: string | null;
    motherName: string | null;
    idCardNo: string | null;
    passportNo: string | null;
    otherNo: string | null;
    nameday: Date | null;
    birthSurname: string | null;
    birthFirstname: string | null;
    birthName: string | null;
    phoneNo: string | null;
    mobilNo: string | null;
    email: string | null;
    drivingLicNo: string | null;
    drivingLicType: string | null;
    drivingLicDate: Date | null;
    addresscardNo: string | null;
    nationality: string | null;
    tajNumber: string | null;
    extCode: string | null;
    insDate: Date;
    insUserId: number;
    insTime: Date;
    isDefault: boolean;
    nexon: string | null;
    addressType: number;
    workrideType: number;
    corpBusRoute: number;
    isjobHousing: boolean;
    jobHousingCity: number;
    jobHousingAddress: string | null;
    housingFromdate: Date | null;
    housingTodate: Date | null;
    monthlyCost: number;
    idCardExpDate: Date | null;
    deleted: boolean;
    hasProdRelation: boolean;
    partPersonRelation: PartPersonRelation;

    inEdit: boolean;
}

export const PartPersonDefaultProps: PartPerson = {
    // id: 0,
    // name: "",
    // sex: false,
    // profession: "",
    // city: "",
    // postcode: "",
    // address: "",
    // otherNo: "",
    // email: "",
    // mobile: "",
    // deleted: false,
    // inEdit: false,
    // partnerId: 0,
    id: 0,
    partnerId: 1,
    fullName: "-",
    firstName: null,
    marriedStatus: 2,
    marriedStatusName: null,
    sex: false,
    birthday: null,
    profession: null,
    employType: 1,
    employeTypeName: null,
    city: 0,
    cityName: "-",
    cityPostCode: "-",
    address: null,
    fullNameCode: "-",
    addressCode: null,
    birthPlace: null,
    motherName: null,
    idCardNo: null,
    passportNo: null,
    otherNo: null,
    nameday: null,
    birthSurname: null,
    birthFirstname: null,
    birthName: null,
    phoneNo: null,
    mobilNo: null,
    email: null,
    drivingLicNo: null,
    drivingLicType: null,
    drivingLicDate: null,
    addresscardNo: null,
    nationality: null,
    tajNumber: null,
    extCode: null,
    insDate: new Date(),
    insUserId: 1,
    insTime: new Date(),
    isDefault: false,
    nexon: null,
    addressType: 1,
    workrideType: 1,
    corpBusRoute: 1,
    isjobHousing: false,
    jobHousingCity: 1,
    jobHousingAddress: null,
    housingFromdate: null,
    housingTodate: null,
    monthlyCost: 0,
    idCardExpDate: null,
    deleted: false,
    hasProdRelation: false,
    partPersonRelation: {...PartPersonRelationDefaultProps},

    inEdit: false,
}
export const PartPersonValidationRules: ValidationRules = {
    fullName: [
        (v: string) => !!v || "Kötelező",
        (v: string) => v.replace(/\s+/g, "").length >= 4 || "Nem lehet rövidebb, mint 4 karakter",
    ],
    birthName: [
        (v: string) => (v.length <= 1 || v.replace(/\s+/g, "").length >= 4) || "Nem lehet rövidebb, mint 4 karakter",
    ],
    motherName: [
        (v: string) => (v.length == 0 || v.replace(/\s+/g, "").length >= 4) || "Nem lehet rövidebb, mint 4 karakter",
    ],
    address: [
        (v: string) => (v.length == 0 || v.replace(/\s+/g, "").length >= 6) || "Nem lehet rövidebb, mint 6 karakter",
    ],
    mobilNo: [
        (v: string) => (v.length == 0 || v.replace(/\s+/g, "").length >= 7) || "Nem lehet rövidebb, mint 7 karakter",
    ],
    email: [
        (v: string) => (v.length == 0 || new RegExp("^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$").test(v)) || "Nem megfelelő formátum",
    ],
    idCardNo: [
        (v: string) => (v.length == 0 || v.replace(/\s+/g, "").length >= 7) || "Nem lehet rövidebb, mint 7 karakter",
    ],
    addresscardNo: [
        (v: string) => (v.length == 0 || v.replace(/\s+/g, "").length >= 5) || "Nem lehet rövidebb, mint 5 karakter",
    ],
    tajNumber: [
       (v: string) => (v.length == 0 || new RegExp("^\\d{9}$").test(v)) || "Nem megfelelő formátum",
    ],
}